module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 76300.9893515c.png";